		// Pour une documentation complète sur API, incluant des exemples de code, allez sur http://wix.to/94BuAAs
import wixLocation from 'wix-location'; 

$w.onReady(function () {
	//TODO: write your page related code here...
wixLocation.to("https://sallevirtuelle.25eheure.com/");
});